<app-main-nav-bar></app-main-nav-bar>
<div class="container bootstrap snippet">
  <div class="row">
    <div class="col-sm-10"><h1>اطلاعات کاربری</h1></div>
  </div>
  <br>
  <div class="row">
    <form [formGroup]="Group">
      <div class="col-sm-3"><!--left col-->
        <div class="panel panel-default">
          <div class="panel-heading"><i class="fa fa-link fa-1x"></i>جنسیت</div>
          <div class="panel-body">
            <div class="form-group" [formGroup]="Group">
              <div class="col-md-12 col-sm-12">
                <label for="state"><h4>جنسیت</h4></label>
                <select class="form-control" style="width: 100%" formControlName="gender" id="state1">
                  <option *ngFor="let item of genderList" value="{{item.value}}"
                          placeholder="جنسیت"
                          title="لطفا جنسیت خود را وارد نمایید">
                    {{item.label}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/col-3-->
      <div class="col-sm-9">
        <ul class="nav nav-tabs">
          <li class="active"><a data-toggle="tab" href="#home">پروفایل کاربری</a></li>
          <!-- <li><a data-toggle="tab" href="#messages">سفارش های من</a></li>
           <li><a data-toggle="tab" href="#settings">معرفی</a></li>-->
        </ul>

        <div class="tab-content">
          <div class="tab-pane active" id="home">
            <hr>
            <form class="form" id="registrationForm">
              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="first_name"><h4>نام</h4></label>
                  <input type="text" class="form-control" name="first_name" id="first_name"
                         placeholder="نام" title="لطفا نام خود را وارد نمایید" formControlName="firstName">
                </div>
              </div>
              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="last_name"><h4>نام خانوادگی</h4></label>
                  <input type="text" class="form-control" name="last_name" id="last_name"
                         placeholder="نام خانوادگی" title="لطفا نام خانوادگی خود را وارد نمایید"
                         formControlName="lastName">
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <app-normal-calender [fieldName]="'birthday'" [dateValue]="Group.controls.birthday.value"
                                     [Group]="Group" [fieldLabel]="'تاریخ تولد'"></app-normal-calender>
              </div>
              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="family_name"><h4>نام پدر</h4></label>
                  <input type="text" class="form-control" name="family_name" id="family_name"
                         formControlName="fathersName"
                         placeholder="نام پدر" title="لطفا نام پدر خود را وارد نمایید">
                </div>
              </div>

              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="code"><h4>کد ملی</h4></label>
                  <input type="text" class="form-control" id="code" placeholder="کد ملی"
                         title="لطفا کد ملی خود را وارد نمایید" formControlName="nationalCode">
                </div>
              </div>

              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="state"><h4>استان</h4></label>
                  <select class="form-control" style="width: 100%" formControlName="stateID"
                          (change)="onStateChange()" id="state">
                    <option *ngFor="let state of states$" value="{{state.value}}"
                            placeholder="استان"
                            title="لطفا استان خود را وارد نمایید">
                      {{state.label}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="city"><h4>شهر</h4></label>
                  <select class="form-control" style="width: 100%" formControlName="cityID" id="city">
                    <option *ngFor="let city of cities$" value="{{city.value}}" placeholder="شهر"
                            title="لطفا شهر خود را وارد نمایید">{{city.label}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="mobile"><h4>موبایل</h4></label>
                  <input disabled type="text" class="form-control" name="mobile" id="mobile" placeholder="موبایل"
                         title="لطفا شماره موبایل خود را وارد نمایید" formControlName="mobile">
                </div>
              </div>

              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="address"><h4>آدرس</h4></label>
                  <input type="text" class="form-control" name="address" id="address"
                         placeholder="آدرس" title="لطفا آدرس خود را وارد نمایید" formControlName="address">
                </div>
              </div>
              <div class="form-group" [formGroup]="Group">
                <div class="col-md-6 col-sm-12">
                  <label for="email">
                    <h4>ایمیل</h4>
                  </label>
                  <input type="email" class="form-control" name="email" id="email" formControlName="email"
                         placeholder="hashtagbime@email.com" title="لطفا ایمیل خود را وارد نمایید">
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-12">
                  <br>
                  <br>
                  <button [disabled]="!Group.valid" (click)="submit()" class="btn btn-lg btn-primary pull-left"
                          type="submit"><i
                    class="glyphicon glyphicon-ok-sign"></i> ذخیره
                  </button>
                  <!--<button class="btn btn-lg btn-info pull-left" type="reset"><i
                          class="glyphicon glyphicon-repeat"></i>بازیابی
                  </button>-->
                </div>
              </div>
            </form>
            <hr>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
